import { api } from '../../DefaultService';
import {
  ICustomerRecognitionCreateProps,
  ICustomerRecognitionProps,
  ICustomerRecognitionUpdateParams,
} from './types';

const ENDPOINT = 'v1/recognitions/customers';

export const createCustomerRecognitionAsync = async (
  data: ICustomerRecognitionCreateProps,
): Promise<ICustomerRecognitionProps> => {
  return await api
    .post(`${ENDPOINT}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const updateCustomerRecognitionAsync = async ({
  id,
  data,
}: ICustomerRecognitionUpdateParams): Promise<ICustomerRecognitionProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const getCustomerRecognitionByIdAsync = async (
  id: number,
): Promise<ICustomerRecognitionProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};
